module.exports = __webpack_public_path__ + "img/loudspeaker.6a2bfec1.svg";